'use client';

import React, { useMemo } from 'react';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import MuiXLicense from '../mui/MuiXLicense';
import { FlattenedUser } from '../types/user';
import ApolloContextProvider from '../context/ApolloContextProvider';
import MuiThemeProvider from '../context/MuiThemeProvider/MuiThemeProvider';
import { ModalContextProvider } from '../context/ModalContextProvider';
import { NavigationBlockingContextProvider } from '../context/NavigationBlockingContextProvider';
import { SimpleAlert } from '../mui/SimpleAlert';
import { makeStore } from '../redux/store';
import { Page } from '../blocks/Page';

type ProvidersProps = {
	children: React.ReactNode;
	initialUser?: FlattenedUser;
};

export default function Providers( { children, initialUser }: ProvidersProps ) {
	const store = useMemo(
		() =>
			makeStore(
				initialUser
					? {
						user: initialUser,
					  }
					: undefined
			),
		[ initialUser ]
	);

	return (
		<ApolloContextProvider>
			<MuiXLicense />
			<MuiThemeProvider>
				<Provider store={ store }>
					<SnackbarProvider
						maxSnack={ 5 }
						Components={ {
							success: SimpleAlert,
							error: SimpleAlert,
						} }
					>
						<ModalContextProvider>
							<NavigationBlockingContextProvider>
								<Page>{ children }</Page>
							</NavigationBlockingContextProvider>
						</ModalContextProvider>
					</SnackbarProvider>
				</Provider>
			</MuiThemeProvider>
		</ApolloContextProvider>
	);
}
